<div class="comments-container">
  @for (commentGroup of commentsGroupedByDate() | keyvalue: sortByDateAscending; track commentGroup.key) {
    @for (comment of commentGroup.value; track comment.id) {
      <coin-v2-comment
        [isOwnComment]="comment.createdBy?.id === currentUserId()"
        [comment]="comment"
        [commentExtension]="commentExtension()"></coin-v2-comment>
    }
    <div class="date-divider">
      <coin-v2-divider
        orientation="horizontal"
        color="dark"></coin-v2-divider>
      <div class="date-indicator-panel">
        <p class="date-indicator">{{ commentGroup.key }}</p>
      </div>
    </div>
  }
</div>
<div class="input-section">
  <coin-v2-text-area
    [formControl]="textInput"
    [placeholder]="'general.enter-comment' | translate"
    (keydown.enter)="$event.preventDefault(); send()"></coin-v2-text-area>
  <coin-v2-button
    iconPos="right"
    type="primary"
    icon="send"
    text="Send"
    [disabled]="!textInput.value"
    (click)="send()"></coin-v2-button>
</div>
